import { render, staticRenderFns } from "./JeecgOrderCustomerList.vue?vue&type=template&id=032e064e&scoped=true"
import script from "./JeecgOrderCustomerList.vue?vue&type=script&lang=js"
export * from "./JeecgOrderCustomerList.vue?vue&type=script&lang=js"
import style0 from "./JeecgOrderCustomerList.vue?vue&type=style&index=0&id=032e064e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "032e064e",
  null
  
)

export default component.exports